
    import Application from "./app/app";
    import environment from "./app/config/environment";

    Application.create(environment.APP);
  